<template>
  <div>
    <div class="top-bander"></div>
    <div class="form-item">
      <div class="fori-title">网络昵称</div>
      <div>
        <van-field class="my-input" v-model="formData.nickname" placeholder="请输入网络昵称"/>
      </div>
    </div>
    <div class="form-item">
      <div class="fori-title">姓名</div>
      <div>
        <van-field class="my-input" v-model="formData.name" placeholder="请输入真实姓名"/>
      </div>
    </div>
    <van-row>
      <van-col span="8">
        <div class="form-item">
          <div class="fori-title">性别</div>
          <div>
            <van-dropdown-menu class="my-select">
              <van-dropdown-item v-model="formData.sex" :options="sexList" />
            </van-dropdown-menu>
          </div>
        </div>
      </van-col>
      <van-col span="16">
        <div @click="showCalendar = true" class="form-item">
          <div class="fori-title">生日</div>
          <div>
            <div class="jia-input flex_c_m">{{formData.birthday}}</div>
          </div>
        </div>
      </van-col>
    </van-row>
    <div @click="areaShow = true" class="form-item">
      <div class="fori-title">居住地</div>
      <div>
        <div class="jia-input flex_c_m">
          {{formData.province}}
          {{formData.city}}
          {{formData.area}}
        </div>
      </div>
    </div>
    <div class="form-item">
      <div class="fori-title">所在小区</div>
      <div>
        <van-field class="my-input" v-model="formData.address" placeholder="请填写具体小区名称"/>
      </div>
    </div>
    <div class="form-item">
      <div class="fori-title">手机号</div>
      <div>
        <van-field class="my-input" v-model="formData.mobile" placeholder="请输入真实手机号"/>
      </div>
    </div>
    <van-row>
      <van-col span="16">
        <div class="form-item">
          <div class="fori-title">手机验证码</div>
          <div>
            <van-field class="my-input" v-model="formData.verifyCode" placeholder="请输入短信验证码"/>
          </div>
        </div>
      </van-col>
      <van-col span="8">
        <div @click="getPhoneCode" class="form-item-code flex_c_m">
          获取验证码
        </div>
      </van-col>
    </van-row>
    <div class="flex_c_m foorl-btn">
      <van-button type="default" class="btn-green" @click="formSub">注册</van-button>
    </div>
    <!-- 生日弹层 -->
    <van-calendar v-model="showCalendar" @confirm="onConfirm" />
    <!-- 地区弹层 -->
    <van-popup v-model="areaShow" position="bottom">
      <AreaSlect @onConse="areaShow=false" @onSuccess="areaSub"></AreaSlect>
    </van-popup>
  </div>
</template>

<script type="text/javascript">
import AreaSlect from '@components/AreaSlect'
import {setLocal,getLocal} from '@utils/tools.js'
	import {
		wxTools
	} from '@utils'
export default {
  data() {
    return {
      showCalendar: false,
      areaShow:false,
      sexList: [
        { text: '男', value: 0 },
        { text: '女', value: 1 },
      ],
      formData:{
        nickname:'', //昵称
        name:'', //名称
        sex:0, //性别
        address:'', //地址
        province:'', //省
        city:'', //市
        area:'', //区
        birthday:'', //生日
        mobile:'', //手机号
        verifyCode:'', //验证码
        openid:'',
      }
    }
  },
  components:{
    AreaSlect
  },
  created() {
    this.getUserinfo()
  },
  methods:{
    getUserinfo() {
				let userInfo = !!getLocal({
					key: 'userInfo',
					parse: true
				});
				if (!userInfo) {
					console.log(11111)
					if (this.$route.query.code) {
						this.$api.user.getWxUser({
							code: this.$route.query.code
						}, res => {
							if(res.data){
								setLocal({
									key: 'userInfo',
									val: res.data
								});
							}
						})
					}
				}
			},
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    // 生日选中
    onConfirm(e){
      this.showCalendar = false;
      this.formData.birthday =  this.formatDate(e);
    },
    // 地区选中
    areaSub(e){
      this.formData.province = e[0].name;
      this.formData.city = e[1].name;
      this.formData.area = e[2].name;
      this.areaShow = false;
    },
    // 获取验证码
    getPhoneCode(){
      if(this.formData.mobile==''){
        this.$toast('请输入手机号');
        return;
      }
      this.$api.user.setSendSms({mobile:this.formData.mobile},res=>{
        this.$toast('发送成功...');
      })
    },
    // 确认注册
    formSub(){
      let uinfo = getLocal({key:'userInfo',parse:true});
      if(uinfo){
        this.formData.openid = uinfo.wx.openid;
      }else{
        this.$toast('请先登录！');
        return;
      }
      this.$api.user.setRegistered(this.formData,res=>{
        let usinfo = getLocal({key:'userInfo',parse:true});
        usinfo.user = res.data;
        setLocal({key:'userInfo',val:usinfo});
        this.$toast('注册成功，正在跳转到投票页...');
        setTimeout(() => {
          this.$router.push({path:'/lineVote',query:{voteCode:this.$route.query.voteCode}});
        }, 1000);
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.top-bander{
  height: 200px;
  width: 100%;
  background: url('~@assets/images/img/Group 5.png') no-repeat;
  background-size: 100% 100%;
  margin-bottom: 40px;
}
.form-item{
  margin: 0 25px 20px 25px;
  font-size: 14px;
  color: #666;
  .fori-title{
    margin-bottom: 8px;
  }
}
.jia-input{
  border:solid 1px #38C7B4;
  height: 45px;
  border-radius:7px;
  background: url('~@assets/images/icon/arrow copy.png') no-repeat 95% center;
  background-size: 20px 20px;
}
.form-item-code{
  font-size: 15px;
  color: #38C7B4;
  height: 45px;
  margin-top: 25px;
}
.foorl-btn{
  margin: 50px 0;
  .btn-green{
    width: 295px;
  }
}
</style>
<style lang="scss">
.my-input{
  padding: 0;
  .van-field__control{
    border:solid 1px #38C7B4;
    height: 45px;
    border-radius:7px;
    padding: 0 15px;
  }
}
.my-select{
  border:solid 1px #38C7B4;
  height: 45px;
  border-radius:7px;
}
</style>
